import React, { useState } from "react";
import "./AppointmentScheduler.scss";
import { Spinner } from "@shopify/polaris";
import CalendarIcon from "../../assets/calendar-over-blue-blotch.png";
import useAppointmentType from "../../hooks/appointments/useAppointmentType";
import { useGlobalContext } from "../../context/GlobalComponentsContext";
import { useMutation } from "@apollo/client";
import { CREATE_APPOINTMENT } from "../../queries";
import AppointmentDateTimePicker from "./AppointmentDateTimePicker";
import { StyleSheet, css } from "aphrodite";
import useSchedulingUser from "../../hooks/appointments/useSchedulingUser";
import { logEvent } from "../../actions";
import { reportError } from "../../utils/errorUtils";

export const AppointmentSchedulerContext = React.createContext();

export default function AppointmentScheduler({
  appointmentId,
  appointmentContactMethod = "Phone Call",
  onAppointmentScheduled
}) {
  const [processing, setProcessing] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState();

  const { showError } = useGlobalContext();

  const { appointmentType, loading: apptLoading } = useAppointmentType(appointmentId);
  const { user, loading: userLoading } = useSchedulingUser();

  const [createAppointmentMutation] = useMutation(CREATE_APPOINTMENT);

  const handleCreateAppointment = async () => {
    try {
      setProcessing(true);
      const result = await createAppointmentMutation({
        variables: {
          appointmentTypeId: appointmentType.id,
          attendeeIds: [user?.id, selectedTimeSlot.userId],
          date: selectedTimeSlot.startTime,
          contactMethod: appointmentContactMethod
        }
      });

      const appointment = result.data.createAppointment;
      onAppointmentScheduled(appointment);
      logEvent("consultAppointmentScheduled");
    } catch (error) {
      reportError(error);
      showError();
    } finally {
      setProcessing(false);
    }
  };

  if (apptLoading || userLoading || processing) {
    return (
      <div className={css(styles.spinnerContainer)}>
        <Spinner />
      </div>
    );
  }

  return (
    <AppointmentSchedulerContext.Provider
      value={{
        appointmentType,
        appointmentContactMethod,
        selectedTimeSlot,
        setSelectedTimeSlot
      }}
    >
      <div className={css(styles.container)}>
        <img src={CalendarIcon} className={css(styles.calendarIcon)} />
        {!!appointmentType && <AppointmentDateTimePicker onContinuePressed={handleCreateAppointment} />}
      </div>
    </AppointmentSchedulerContext.Provider>
  );
}

const smallScreen = window.innerWidth < 500;

const styles = StyleSheet.create({
  spinnerContainer: {
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
    flex: 1
  },
  container: {
    margin: "5%",
    marginBottom: "5%",
    marginLeft: smallScreen ? "5px" : "15%",
    marginRight: smallScreen ? "5px" : "15%",
    backgroundColor: "#FFFFFF",
    flex: 1,
    paddingBottom: 30,
    boxShadow: "5px 5px 23px -6px rgba(0, 0, 0, 0.25)",
    minWidth: smallScreen ? 350 : 420
  },
  calendarIcon: {
    maxWidth: 175,
    width: "15%",
    aspectRatio: 1,
    position: "absolute",
    zIndex: 1000
  }
});
